import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES, ROUTESproductCategory } from './menu-items';
import { RouteInfo } from './sellersidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import { KycService } from '../../services/kyc.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-sellersidebar',
  templateUrl: './sellersidebar.component.html'
})
export class SellerSidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  user: any;
  userId: any;
  userEmail: any;
  profilePic: any;
  URL: any;
  imageUrl: any;
  public sidebarnavItems: any[];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private _httpService: KycService
  ) {}

  // End open close
  ngOnInit() {
    this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    if(localStorage.getItem('productCategory') === "Purchase Invoice Discounting") {
      this.sidebarnavItems = ROUTESproductCategory.filter(sidebarnavItem => sidebarnavItem);
    }
    this.user = localStorage.getItem('sellerName');
    this.userId = localStorage.getItem('sellerId');
    this.userEmail = localStorage.getItem('sellerEmail');
    console.log('inside oninit', this.userEmail);
    this._httpService.getProfilePicHash(this.userEmail).subscribe(
      data => {
          this.profilePic = (data);
          console.log('pp', this.profilePic);
          const dataVal = this.profilePic.items;
          for (const item of dataVal) {
              this.URL = item.URL;
              console.log('URL', this.URL);
          }
          if (this.profilePic.responseStatus === 200) {
              console.log('200');
                console.log('URL ddd', this.URL);
                this.imageUrl = this.URL;
          }
          } ,
          error =>  {
            this.handleError(error);
          },
      () => console.log('created employee', this.profilePic));
  }

  handleError(error) {
    this.imageUrl = 'assets/images/users/pp.png';
    console.log('error', error.error);
    console.log('status code', error.responseStatus);
    if (error.responseStatus === 400) {
      console.log('inside if');
      // swal({
      //     
      //     text: error.error,
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#535BE2',
      //     cancelButtonColor: '#FF7E39',
      //     confirmButtonText: 'OK',
      //   }).then((confirm) => {
      //         if (confirm) {
      //           this.router.navigate(['/buyer/mr']);
      //         }
      //       });
    }
    if (error.responseStatus === 401) {
        console.log('inside if');
        console.log(error);
        console.log(error.error);
        swal({
            
            text: error.message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#535BE2',
            cancelButtonColor: '#FF7E39',
            confirmButtonText: 'OK',
          }).then((confirm) => {
                if (confirm) {
                  this.router.navigate(['/login']);
                }
              });
      }
      if (error.responseStatus === 500) {
        console.log('inside if');
        swal({
          
          text: error.error,
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#535BE2',
          cancelButtonColor: '#FF7E39',
          confirmButtonText: 'OK',
        }).then((confirm) => {
              if (confirm) {
                // this.router.navigate(['/buyer/mr']);
              }
            });
      }
  }
}
